export default function stringHelper(url: string) {
  url = url
    .trim()

    .replace(/[\+\$\!\(\)\s\.;\/:*?""<>|&,'\]\[\s-\–#]/gim, '_')
    .toLowerCase()
    .replace(/__/gim, '_')
  url = url.replace(/__/gim, '_')
  url = url[url.length - 1] == '_' ? url.substring(0, url.length - 1) : url
  return url
}
